import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Cancel = () => {
  const navigate = useNavigate();

  useEffect(() => {
    alert('Payment was canceled!');
    navigate('/');
  }, [navigate]);

  return null;
};

export default Cancel;
